// extracted by mini-css-extract-plugin
export var apartments = "Dormitories-module--apartments--80708";
export var core = "Dormitories-module--core--18c1a";
export var dorms = "Dormitories-module--dorms--faade";
export var empreendimento = "Dormitories-module--empreendimento--9ac30";
export var facadeInfo = "Dormitories-module--facadeInfo--39e65";
export var facadeItem = "Dormitories-module--facadeItem--4996c";
export var facadeNight = "Dormitories-module--facadeNight--ca809";
export var img1 = "Dormitories-module--img1--7ed36";
export var img2 = "Dormitories-module--img2--c79ec";
export var links = "Dormitories-module--links--924ac";
export var logo = "Dormitories-module--logo--d077c";
export var modalList = "Dormitories-module--modal-list--374b2";
export var toggleFachada = "Dormitories-module--toggleFachada--37dbd";
export var toggleItem = "Dormitories-module--toggleItem--9305c";